import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { getBookingDetail } from "../api/appointment";

function BookingDetailPage() {
  const navigate = useNavigate();
  const [bookingData, setBookingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBookingDetail = async () => {
      setError(null);
      try {
        const res = await getBookingDetail();
        if (res.status === true) {
          setBookingData(res.data);
        } else {
          setError(res.msg || "Gagal mengambil data booking");
        }
      } catch (err) {
        setError(err?.response?.data?.msg || "Terjadi kesalahan pada server.");
      } finally {
        setLoading(false);
      }
    };
    fetchBookingDetail();
  }, []);

  const handleReschedule = () => {
    navigate("/");
  };

  return (
    <>
      {/* CSS INTERNAL UNTUK MENYAMAKAN STYLE HTML ANDA */}
      <style>{`
        body {
          padding: 110px 20px 40px;
          color: #333;
          background-color: #fff;
        }
        .header-fixed {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 72px;
          background-color: #fff;
          z-index: 1030;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #eee;
        }
        .nav-link-custom {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          text-decoration: none;
        }
        .text-brand { color: #ff2d55; }
        .btn-masuk {
          background-color: #00a631;
          border: none;
          color: white;
          font-weight: bold;
          padding: 10px;
          width: 100%;
          border-radius: 8px;
          margin-top: 20px;
          display: block;
          text-align: center;
          text-decoration: none;
        }
        .btn-masuk:hover { background-color: #008f2a; color: white; }
        .card { border-radius: 12px; border: 1px solid #eee; box-shadow: 0 2px 10px rgba(0,0,0,0.05); }
      `}</style>

      {/* HEADER (Sesuai HTML Anda) */}
      <header className="header-fixed">
        <div className="container-fluid px-4">
          <div className="d-flex align-items-center justify-content-between">
            <Link to="/">
              <img src="/images/logo.png" height="36" alt="Logo" />
            </Link>
            <nav className="d-none d-md-flex gap-4 align-items-center">
              <Link to="/" className="nav-link-custom">
                Home
              </Link>
              <Link to="/" className="nav-link-custom">
                About
              </Link>
              <Link to="/login" className="nav-link-custom">
                My Booking
              </Link>
            </nav>
          </div>
        </div>
      </header>

      <div className="container">
        <div className="content mx-auto" style={{ maxWidth: "1200px" }}>
          <h5 className="fw-semibold text-brand mb-3">Booking Detail Anda</h5>

          {/* LOADING STATE */}
          {loading && (
            <div className="text-center py-5">
              <div className="spinner-border text-danger" role="status"></div>
              <p className="mt-2 text-muted">Memuat data...</p>
            </div>
          )}

          {/* ERROR STATE */}
          {error && (
            <div className="alert alert-danger shadow-sm border-0 mb-4">
              <i className="bi bi-exclamation-circle me-2"></i> {error}
            </div>
          )}

          {/* DETAIL CARD (Sesuai Struktur HTML Anda) */}
          {!loading && bookingData && (
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="card p-4">
                  <div className="mb-3 border-bottom pb-2">
                    <small className="text-muted d-block">Kode Booking</small>
                    <span className="fw-bold">{bookingData.booking_code}</span>
                  </div>

                  <div className="mb-3 border-bottom pb-2">
                    <small className="text-muted d-block">Nama</small>
                    <span className="fw-bold">{bookingData.name}</span>
                  </div>

                  <div className="row mb-3">
                    <div className="col-6 border-bottom pb-2">
                      <small className="text-muted d-block">
                        Tanggal Booking
                      </small>
                      <span>{bookingData.konseling_date_formatted}</span>
                    </div>
                    <div className="col-6 border-bottom pb-2">
                      <small className="text-muted d-block">Jam Booking</small>
                      <span>{bookingData.jam_konseling}</span>
                    </div>
                  </div>

                  <div className="mb-3 border-bottom pb-2">
                    <small className="text-muted d-block">
                      Produk Konseling
                    </small>
                    <span className="text-wrap">
                      {bookingData.product_konseling}
                    </span>
                  </div>

                  <div className="row mb-3">
                    <div className="col-6 border-bottom pb-2">
                      <small className="text-muted d-block">Bahasa</small>
                      <span>{bookingData?.bahasa_konseling}</span>
                    </div>
                    <div className="col-6 border-bottom pb-2">
                      <small className="text-muted d-block">Durasi</small>
                      <span>{bookingData.duration} Menit</span>
                    </div>
                  </div>

                  <div className="mb-3 border-bottom pb-2">
                    <small className="text-muted d-block">Psikolog</small>
                    <span>{bookingData.psikolog}</span>
                  </div>

                  <div className="mb-4">
                    <small className="text-muted d-block">Status</small>
                    <span
                      className={`badge rounded-pill ${bookingData.status === "finished" ? "bg-success" : "bg-warning text-dark"}`}
                    >
                      {bookingData.status}
                    </span>
                  </div>

                  {/* Button Reschedule jika diizinkan */}
                  {bookingData.is_reschedule && (
                    <button
                      className="btn btn-masuk w-100"
                      onClick={handleReschedule}
                    >
                      Reschedule Jadwal Booking
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default BookingDetailPage;
